/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./configuration.defs.js";
export { main as default } from "./configuration.defs.js";
